// removed by extract-text-webpack-plugin
module.exports = {"mainText":"AtpUpdateBanner__mainText___3K1m7"};


//////////////////
// WEBPACK FOOTER
// ./src/card/CardDialogs/AtpUpdateBanner/AtpUpdateBanner.scss
// module id = 1220
// module chunks = 0